<template>
  <ProductSeriesPage
    :title="title"
    :title-lines="titleLines"
    :subtitle="subtitle"
    :hero-image="heroImage"
    :hero-copy-class="heroCopyClass"
    :hero-title-class="heroTitleClass"
    :items="items"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ProductSeriesPage from '@/components/ProductSeriesPage.vue'

import heroImage from '@/assets/images/pixso-industry-official/domain-control-series.jpg'
import dc100Image from '@/assets/images/pixso-industry-official/dc100.png'
import dc200Image from '@/assets/images/pixso-industry-official/dc200.png'

const { locale, t, tm } = useI18n()

const title = computed(() => t('IndustryDomainControlSeries.title'))
const subtitle = computed(() => '')
const titleLines = computed(() => {
  const lines = tm('IndustryDomainControlSeries.titleLines')
  return Array.isArray(lines) ? lines : []
})
const isEnglish = computed(() => locale.value.startsWith('en'))
const heroCopyClass = computed(() => (
  isEnglish.value ? 'product-series__hero-copy--wide-title' : ''
))
const heroTitleClass = computed(() => (
  isEnglish.value ? 'product-series__hero-title--balanced-two-line' : ''
))

const items = computed(() => [
  {
    title: t('IndustryDomainControlSeries.cards.dc100.title'),
    description: t('IndustryDomainControlSeries.cards.dc100.desc'),
    image: dc100Image,
    to: '/product/industry/domain-control/dc100'
  },
  {
    title: t('IndustryDomainControlSeries.cards.dc200.title'),
    description: t('IndustryDomainControlSeries.cards.dc200.desc'),
    image: dc200Image,
    to: '/product/industry/domain-control/dc200'
  }
])
</script>
